<script lang="ts" setup>
interface Props {
  error: {
    statusCode: number;
    message: string;
  };
}

defineProps<Props>();
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-4 bg-white p-8 rounded-xl w-full max-w-[562px] max-[444px]:h-full max-[444px]:rounded-none">
    <p class="text-[128px] font-bold leading-tight text-blue-600">
      {{ error.statusCode }}
    </p>
    <h1 class="text-2xl font-bold text-center max-[576px]:text-xl">
      Что-то пошло не так...
    </h1>
    <p class="text-center">
      В настоящее время сайт недоступен по техническим причинам. Попробуйте
      перезагрузить страницу или зайти позже. Просим прощения за неудобства
    </p>
  </div>
</template>
